import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const beneficiosGratidao = [
  {
    icon: 'ri-brain-line',
    titulo: 'Neuroplasticidade',
    desc: 'Gratidão consistente ativa o córtex pré-frontal e libera dopamina, fortalecendo redes neurais associadas ao bem-estar e foco.',
  },
  {
    icon: 'ri-emotion-happy-line',
    titulo: 'Regulação Emocional',
    desc: 'Prática diária reduz cortisol e aumenta serotonina — criando base emocional estável para decisões de alta performance.',
  },
  {
    icon: 'ri-focus-3-line',
    titulo: 'Clareza de Objetivos',
    desc: 'O hábito de reconhecer conquistas treina o sistema reticular a identificar mais oportunidades e progresso real.',
  },
  {
    icon: 'ri-award-line',
    titulo: 'Reforço de Identidade',
    desc: 'Registrar vitórias diárias consolida a identidade de alta performance — transformando comportamentos excepcionais em padrão.',
  },
];

const statsGratidao = [
  { value: '31%', label: 'Melhora em produtividade', icon: 'ri-line-chart-line' },
  { value: '23%', label: 'Redução de estresse', icon: 'ri-heart-pulse-line' },
  { value: '19%', label: 'Mais qualidade de sono', icon: 'ri-moon-line' },
];

export default function CadernoGratidao() {
  return (
    <section className="py-28 bg-[#0d0d0d] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_40%,rgba(201,164,64,0.05),transparent_55%)]"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Lado esquerdo — copy */}
          <ScrollRevealWrapper animation="fade-right">
            <div>
              <div className="inline-flex items-center gap-3 mb-6">
                <div className="h-px w-6 bg-gold-500/50"></div>
                <span className="text-gold-400 text-xs font-semibold tracking-[0.25em] uppercase font-['Montserrat']">
                  Caderno de Gratidão Digital
                </span>
              </div>

              <h2 className="font-display text-5xl font-bold text-white leading-tight mb-5">
                O hábito que separa<br />
                <span className="text-gold-400">líderes extraordinários.</span>
              </h2>

              <p className="text-white/55 leading-relaxed font-['Montserrat'] text-sm mb-10 font-light">
                Gratidão não é autoajuda — é neurociência aplicada. Líderes de alta performance usam o registro diário de conquistas para reforçar identidade, clareza mental e foco em resultados.
              </p>

              {/* Benefícios */}
              <div className="grid grid-cols-2 gap-4 mb-10">
                {beneficiosGratidao.map((b, i) => (
                  <div key={i} className="bg-[#111111] border border-gold-500/10 rounded-xl p-5 hover:border-gold-500/25 transition-colors">
                    <div className="w-9 h-9 flex items-center justify-center bg-gold-500/10 rounded-lg mb-3">
                      <i className={`${b.icon} text-gold-400 text-base`}></i>
                    </div>
                    <h3 className="font-display text-sm font-bold text-white mb-1">{b.titulo}</h3>
                    <p className="text-white/40 text-xs font-['Montserrat'] leading-relaxed">{b.desc}</p>
                  </div>
                ))}
              </div>

              {/* Stats */}
              <div className="flex gap-6 mb-10 p-5 bg-gradient-to-r from-[#1a1400] to-[#0f0c00] border border-gold-500/15 rounded-xl">
                {statsGratidao.map((s, i) => (
                  <div key={i} className="flex-1 text-center">
                    <div className="w-7 h-7 flex items-center justify-center mx-auto mb-2">
                      <i className={`${s.icon} text-gold-400 text-base`}></i>
                    </div>
                    <div className="font-display text-2xl font-bold text-gold-400">{s.value}</div>
                    <p className="text-white/35 text-xs font-['Montserrat'] leading-tight">{s.label}</p>
                  </div>
                ))}
              </div>

              <Link
                to="/diario"
                className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] rounded-full font-bold hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] text-sm tracking-wide"
              >
                <i className="ri-book-open-line"></i>
                Acessar Caderno de Gratidão
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </ScrollRevealWrapper>

          {/* Lado direito — imagem */}
          <ScrollRevealWrapper animation="fade-left">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] border border-gold-500/15">
                <img
                  src="https://public.readdy.ai/ai/img_res/a8446f0c67887b17e3bd230138586aec.jpg"
                  alt="Caderno de Gratidão"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/40 to-transparent"></div>
              </div>

              {/* Badge de ciência */}
              <div className="absolute top-5 -left-5 bg-[#0d0d0d] border border-gold-500/20 rounded-xl p-4 max-w-[180px]">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-medal-line text-gold-400 text-base"></i>
                  <span className="text-gold-400 text-xs font-bold font-['Montserrat']">Baseado em ciência</span>
                </div>
                <p className="text-white/45 text-xs font-['Montserrat'] leading-tight">
                  Estudos UC Davis e Harvard confirmam impacto neurológico
                </p>
              </div>

              {/* Stats flutuante */}
              <div className="absolute bottom-5 -right-5 bg-[#0d0d0d] border border-gold-500/20 rounded-xl px-5 py-4">
                <div className="font-display text-3xl font-bold text-gold-400">21 dias</div>
                <p className="text-white/45 text-xs font-['Montserrat']">para criar o hábito</p>
              </div>
            </div>
          </ScrollRevealWrapper>
        </div>
      </div>
    </section>
  );
}
